export default "__VITE_ASSET__DcnPkAK5__"